/**
 * ฟังก์ชันสำหรับค้นหานิสิตจากชื่อ (แบบง่ายแต่ได้ผล)
 * @param {string} inputName ชื่อที่ต้องการค้นหา
 * @param {Array} students รายชื่อนิสิตทั้งหมด
 * @returns {Object|null} ข้อมูลนิสิตที่พบ หรือ null ถ้าไม่พบ
 */
export const findStudentByName = (inputName, students) => {
  if (!inputName || !students || students.length === 0) {
    return null;
  }

  // ทำความสะอาดชื่อที่จะค้นหา
  const cleanInputName = inputName.toLowerCase().trim();
  
  if (cleanInputName.length < 2) {
    return null;
  }

  // ฟังก์ชันช่วยสำหรับดึงชื่อเต็มจากข้อมูลนิสิต
  const getFullName = (student) => {
    // ลองหลาย field name ที่เป็นไปได้
    const firstName = student.st_name_th || student.st_name || student.name || student.first_name || '';
    const lastName = student.st_lastname_th || student.st_lastname || student.lastname || student.last_name || '';
    return `${firstName} ${lastName}`.toLowerCase().trim();
  };

  // วิธีที่ 1: ค้นหาแบบ exact match
  for (const student of students) {
    const fullName = getFullName(student);
    
    if (fullName === cleanInputName) {
      return student;
    }
  }

  // วิธีที่ 2: ค้นหาแบบ contains (ชื่อเต็มมีชื่อที่ค้นหาอยู่)
  for (const student of students) {
    const fullName = getFullName(student);
    
    if (fullName.includes(cleanInputName)) {
      return student;
    }
  }

  // วิธีที่ 3: ค้นหาแบบ reverse contains (ชื่อที่ค้นหามีชื่อเต็มอยู่)
  for (const student of students) {
    const fullName = getFullName(student);
    
    if (cleanInputName.includes(fullName) && fullName.length > 3) {
      return student;
    }
  }

  // วิธีที่ 4: ค้นหาจากชื่อหรือนามสกุลอย่างใดอย่างหนึ่ง
  const inputWords = cleanInputName.split(/\s+/).filter(word => word.length > 2);
  
  for (const student of students) {
    const fullName = getFullName(student);
    const words = fullName.split(/\s+/).filter(word => word.length > 2);
    
    for (const inputWord of inputWords) {
      for (const studentWord of words) {
        if (inputWord.length > 2 && studentWord.includes(inputWord)) {
          return student;
        }
      }
    }
  }

  return null;
};

/**
 * ทดสอบ matching algorithm
 * @param {Array} testCases รายการทดสอบ
 * @param {Array} students รายชื่อนิสิต
 */
export const testStudentMatcher = (testCases, students) => {
  console.log('🧪 [StudentMatcher] เริ่มการทดสอบ...');
  
  testCases.forEach((testCase, index) => {
    console.log(`\n--- Test Case ${index + 1}: "${testCase.input}" ---`);
    const result = findStudentByName(testCase.input, students);
    
    if (result) {
      console.log(`✅ พบ: ${result.st_name_th} ${result.st_lastname_th} (${result.req_id})`);
    } else {
      console.log(`❌ ไม่พบ`);
    }
    
    if (testCase.expectedReqId) {
      const isCorrect = result?.req_id === testCase.expectedReqId;
      console.log(`🎯 คาดหวัง: ${testCase.expectedReqId} | ผลลัพธ์: ${isCorrect ? '✅ ถูกต้อง' : '❌ ผิด'}`);
    }
  });
  
  console.log('\n🧪 [StudentMatcher] เสร็จสิ้นการทดสอบ');
};
